
// A number of helper functions related to angles.
export default class Angle {
    // Angle in radians. Normalizes an angle to a value between 0 and a full rotation.
    static normalize(angle) {
        let newAngle = angle;
        while (newAngle < 0)
            newAngle += Math.PI * 2;
        while (newAngle > Math.PI * 2)
            newAngle -= Math.PI * 2;
        return newAngle;
    }

    static toRadians(angle) {
        return angle * (Math.PI / 180)
    }

    static toDegrees(angle) {
        return angle * (180 / Math.PI);
    }

    // Angle in radians, increments and margin in degrees.
    // Snaps to an increment once the angle is within the margin of an increment.
    // Return in radians.
    static snap(angle, increments, margin) {
        const degreesAngle = Angle.toDegrees(Angle.normalize(angle));
        for (let i = 0; i <= 360 + margin; i += increments) {
            if (degreesAngle >= i - margin && degreesAngle < i + margin) {
                return Angle.toRadians(i);
            }
        }
        return angle;
    }

    // All angles in radians. Returns true if angle is within margin of goal.
    static isInRange(angle, goal, marginL, marginR) {
        const angleN = Angle.normalize(angle);
        const goalN = Angle.normalize(goal);
        for (let i = -1; i <= 1; i++) {
            const diff = i * Math.PI * 2;
            if (angleN > goalN - marginL + diff && angleN < goalN + marginR + diff)
                return true;
        }
        return false;
    }
}